<template>
  <v-dialog
    v-model="show"
    width="500"
  >
    <v-card>

      <v-card-title class="justify-center">
        <span class="text-h5">Список уведомлений</span>

        <v-spacer />

        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider class="mb-5" />

      <v-card-text style="position: relative;">
        <v-list>
          <v-list-item
            v-for="notification in notifications"
            :key="notification.id"
            :style="{ backgroundColor: notification.viewed ? '' : '#28A7452A', }"
            @click="viewNotification(notification.id)"
          >
            <v-list-item-title
              :class="notification.viewed ? 'text--success' : ''"
            >
              {{ notification.title }}
            </v-list-item-title>
            <v-list-item-subtitle>{{ notification.created_at }}</v-list-item-subtitle>
          </v-list-item>
        </v-list>

        <v-overlay :value="loading" absolute>
          <v-progress-circular indeterminate color="green" />
        </v-overlay>
      </v-card-text>

      <v-card-actions>
        <v-pagination
          v-if="pagination.total > pagination.per_page"
          v-model="pagination.current_page"
          :length="pagination.last_page"
          :total-visible="7"
          @input="onPageChange"
        />
      </v-card-actions>

    </v-card>

    <NotificationView
      v-model="notificationOpen"
      :id="notificationId"
    />
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import NotificationView from './NotificationView.vue'

export default {
  components: {
    NotificationView
  },
  name: 'NotificationsList',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      notifications: [],
      notificationId: null,
      notificationOpen: false,
      pagination: {
        current_page: 1,
        last_page: 1,
        per_page: 5,
        total: 0,
      },
    }
  },

  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },

  watch: {
    show(val) {
      if (val) {
        this.loadNotifications()
      } else {
        this.notifications.length = 0
      }
    },
  },

  methods: {
    ...mapActions({
      getNotifications: 'notifications/getNotifications',
    }),

    loadNotifications() {
      this.loading = true

      const payload = {
        ...this.pagination,
        all_messages: true,
      }

      this.getNotifications(payload)
        .then(resp => {
          this.notifications = resp.data
          this.pagination = resp.meta
        }).finally(() => {
          this.loading = false
        })
    },

    onPageChange(index) {
      this.pagination.current_page = index
      this.loadNotifications()
    },

    viewNotification(id) {
      this.notificationId = id
      this.notificationOpen = true
    },
  },

  mounted() {},
}
</script>

<style>

</style>